import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { VendorEnquiryCRUD } from '../services/vendorEnquiryService';

const useVendorQuotationCRUD = (callMessage) => {
    const processIndent = useCallback(async (selectedMode, editPurchaseIndentID, requestBody) => {
        try {
            const apiEndpoint = API_ENDPOINTS.VENDOR_RESPONSE_CRUD_PROCESS;

            const successMessage = editPurchaseIndentID!==0 
                    ? 'Vendor Quotation updated Successfully'
                    : 'New Vendor Quotation Created Successfully';

            // Await the API response
            const data = await VendorEnquiryCRUD(apiEndpoint, requestBody);

            if (data?.length > 0) {
                callMessage('info', successMessage, 'info');
                return successMessage; // ✅ Just return string
            } else {
                const errorMsg = 'No data received from API';
                callMessage('error', errorMsg, 'Error');
                return errorMsg;
            }
        } catch (error) {
           const errorMsg = error.message || 'An unexpected error occurred';
        callMessage('error', errorMsg, 'Error');
        return errorMsg;
        }
    }, [callMessage]);

    return { processIndent };
};

export default useVendorQuotationCRUD;

